import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=57cda756&scoped=true&"
import script from "./Edit.vue?vue&type=script&lang=js&"
export * from "./Edit.vue?vue&type=script&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=57cda756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57cda756",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57cda756')) {
      api.createRecord('57cda756', component.options)
    } else {
      api.reload('57cda756', component.options)
    }
    module.hot.accept("./Edit.vue?vue&type=template&id=57cda756&scoped=true&", function () {
      api.rerender('57cda756', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/prize/pool/Edit.vue"
export default component.exports